import { Operation } from "../../../entity/Operation";
import { Method, ROUTES, URLs } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { OperationDto } from "../../dto/Operation.Dto";
import { mapToOperation } from "../../mapper/OperationMapper";

export class WSOperation {
  private static instance: WSOperation;
  private constructor() {}

  /**
   * Singleton instance
   */
  public static getInstance(): WSOperation {
    if (!WSOperation.instance) {
      WSOperation.instance = new WSOperation();
    }
    return WSOperation.instance;
  }

  async getAllOperations(storeId: string): Promise<Operation[]> {
    try {
      const url = `${ROUTES.OPERATIONS}${storeId}`;

      const response = await fetchAPI<OperationDto[]>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });
      return mapToOperation(response.data);
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async addNewOperation(operation: Operation): Promise<string> {
    try {
      const url = `${ROUTES.OPERATIONS}${ROUTES.CREATE_OPERATION}`;

      const response = await fetchAPI<string>({
        url,
        method: Method.POST,
        params: operation,
        isAuthenticated: true,
      });
      return response.data;
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async updateOperation(operation: Operation): Promise<void> {
    try {
      const url = `${ROUTES.OPERATIONS}${ROUTES.UPDATE_OPERATION}`;

      await fetchAPI<string>({
        url,
        method: Method.PUT,
        params: operation,
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Fialed to update operation:", error);
      throw error;
    }
  }

  async deleteOperation(id: string): Promise<void> {
    console.log("id: " + id);
    try {
      const url = `${ROUTES.OPERATIONS}${ROUTES.DELETE_OPERATION}`;

      await fetchAPI<string>({
        url,
        method: Method.DELETE,
        params: { id: id },
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Fialed to delete operation:", error);
      throw error;
    }
  }
}
